import CallIcon from '@mui/icons-material/Call';
import classNames from 'classnames';
import clsx from 'clsx';

import {NetworkQualityIndicator} from '../NetworkQualityIndicator';

import styles from '../videoCall.module.scss';

type VideoRendererProps = {
    isLoading: boolean;
    isConnected: boolean;
};

export const VideoRenderer = ({isLoading, isConnected}: VideoRendererProps) => (
    <>
        {isLoading && (
            <div id="connectionStatus" className="loading">
                <div className="connecting">
                    <CallIcon className={classNames(styles.loadingIcon)} style={{color: 'white', fontSize: '80px'}} />
                    <div style={{color: 'white'}}>Connecting...</div>
                </div>
            </div>
        )}
        <div id="renderer-container" className={clsx(styles.rendererContainer, 'renderer-container')}>
            <div id="renderer" className={styles.renderer} />
            {isConnected && <NetworkQualityIndicator />}
        </div>
    </>
);
